import { TrendingNeutralIcon } from './TrendingNeutralIcon';

/**
 * author: Google
 * id A39F489B-ABB1-4420-A6DC-20AF0E2CF6DA
 * name trending-neutral
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trending-neutral.svg
 * tags
 */
export const TrendingFlatIcon = TrendingNeutralIcon;
export default TrendingFlatIcon